import React from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import SearchableSelect from 'components/SearchableSelect'
import { SkeletonLine } from 'components/Skeleton'
import useMyBuildings from './useMyBuildings'
import { ROLE_LABELS } from 'utils/roles'

const WorkflowBuildingPicker = ({ title, onChoose }) => {
  const { buildings, loading } = useMyBuildings()

  return createPortal(
    <Card role='dialog' aria-label='Choose a building for this guide'>
      <Heading>Which Building Passport?</Heading>
      <Lead>{`We will show you "${title}" using one of your buildings. Pick the one you want to work on.`}</Lead>
      {loading ? (
        <SkeletonLine $h={40} />
      ) : buildings.length ? (
        <SearchableSelect
          value={null}
          onChange={value => value && onChoose(value)}
          options={buildings}
          placeholder='Choose a Building Passport'
          searchPlaceholder='Search your buildings'
          ariaLabel='Which Building Passport?'
        />
      ) : (
        <Lead>You do not have access to any Building Passports yet, so this guide cannot start. Stop the guide below and ask an {ROLE_LABELS.owner} of the building for access.</Lead>
      )}
    </Card>,
    document.body
  )
}

export default WorkflowBuildingPicker

const Card = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100050;
  width: min(440px, calc(100vw - 32px));
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(12, 18, 41, 0.12);
`

const Heading = styled.h2`
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  color: #0C1229;
`

const Lead = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #475467;
`
